/**
 * Format minutes to HH:MM format
 * @param minutes positive number of minutes
 */
export function formatMinutes(minutes: number): string {
	if (minutes <= 0) return "0:00";
	const hours = Math.floor(minutes / 60);
	const mins = minutes - (hours * 60);
	return hours + ':' + mins.toString().padStart(2, '0');
}

/**
 * Formats as percentage
 * @param perc
 */
export function formatPerc(perc: number, decimals = 0): string {
	return `${(perc * 100).toFixed(decimals)} %`;
}


export const OBSCURE_BULLET = '•';
export const OBSCURE_TIMES = '×';

// Helper to check for any kind of letter (Unicode-aware)
function isLetter(ch: string): boolean {
	return /\p{L}/u.test(ch);
}

export function obscureText(text: string | null | undefined, ochar: string = OBSCURE_BULLET): string {
	if (!text) return ochar.repeat(5);

	const words = text.trim().split(/\s+/).filter(w => w.length > 0);
	if (words.length === 0 || (words.length === 1 && words[0].length < 3)) return ochar.repeat(5);

	const obscuredWords = words.map(word => {
		const chars = Array.from(word); // handles Unicode correctly
		const obscured = chars.map((ch, i) => {
			if (
				(i === 0 && ch.toUpperCase() === ch && isLetter(ch)) ||
				ch === '.' || ch === ',' || ch === '-'
			) {
				return ch;
			} else {
				return ochar;
			}
		});
		return obscured.join('');
	});

	return obscuredWords.join(' ');
}


export function formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 B";
    
    const k = 1024;
    const sizes = ["B", "kB", "MB", "GB", "TB", "PB"];
    
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}